<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        get menuList() {
            return {
                // container: "",
                list: [
                    {
                        key: aiStatusType.ganttSummarize,
                        label: this.$t("ganttTotal"),
                        img: "gantt-ai-total",
                    },
                    {
                        key: aiStatusType.ganttProgress,
                        label: this.$t("ganttProgress"),
                        img: "gantt-ai-progress",
                    },
                    {
                        key: aiStatusType.ganttRisk,
                        label: this.$t("ganttRisk"),
                        img: "gantt-ai-risk",
                    },
                    {
                        key: aiStatusType.ganttExpirence,
                        label: this.$t("ganttShare"),
                        img: "gantt-ai-share",
                    },
                    {
                        key: aiStatusType.ganttChat,
                        label: this.$t("more"),
                        img: "ai-menu-more",
                    },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        handleClicks(id) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                const ustr = this.menuList.list.filter((item) => item.key == id)[0].label;
                this.$bus.$emit("aiAnalyse", id, ustr, id == aiStatusType.ganttChat);
                this.aiTrackData(id);
            });
            this.closeDrop();
        }
        aiTrackData(id) {
            let obj = {
                [aiStatusType.ganttSummarize]: "Gantt Chart Analysis",
                [aiStatusType.ganttProgress]: "Gantt Chart Progress",
                [aiStatusType.ganttRisk]: "Gantt Chart Risk",
                [aiStatusType.ganttExpirence]: "Gantt Chart Expirence",
                [aiStatusType.ganttChat]: "Gantt Chart More",
            };
            this.sensors.track("clickAItoolbar", {
                Catalogues: "AI",
                click_type: obj[id],
            });
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "ganttTotal": "项目概述",
    "ganttProgress": "项目进展",
    "ganttRisk": "风险识别",
    "ganttShare": "项目经验分享",
    "more": "更多"
  },
  "en": {
    "ganttTotal": "Project Overview",
    "ganttProgress": "Project Progress",
    "ganttRisk": "Risk Identification",
    "ganttShare": "Lessons Learned",
    "more": "More"
  },
  "fr": {
    "ganttTotal": "Aperçu du projet",
    "ganttProgress": "Avancement du projet",
    "ganttRisk": "Identificación de riesgos",
    "ganttShare": "Leçons apprises",
    "more": "Plus"
  },
  "de": {
    "ganttTotal": "Projektübersicht",
    "ganttProgress": "Projektfortschritt",
    "ganttRisk": "Risikoermittlung",
    "ganttShare": "Gesammelte Erfahrungen",
    "more": "Mehr"
  },
  "jp": {
    "ganttTotal": "プロジェクトの概要",
    "ganttProgress": "プロジェクトの進行状況",
    "ganttRisk": "リスクの特定",
    "ganttShare": "得られた経験",
    "more": "その他"
  },
  "es": {
    "ganttTotal": "Descripción general del proyecto",
    "ganttProgress": "Progreso del proyecto",
    "ganttRisk": "Identificación de riesgos",
    "ganttShare": "Lecciones aprendidas",
    "more": "Más"
  },
  "pt": {
    "ganttTotal": "Visão geral do projeto",
    "ganttProgress": "Progresso do projeto",
    "ganttRisk": "Identificação de risco",
    "ganttShare": "Lições aprendidas",
    "more": "Mais"
  },
  "it": {
    "ganttTotal": "Panoramica del progetto",
    "ganttProgress": "Stato del progetto",
    "ganttRisk": "Identificazione rischio",
    "ganttShare": "Analisi di fine progetto",
    "more": "Altro"
  },
  "tw": {
    "ganttTotal": "專案概覽",
    "ganttProgress": "專案進度",
    "ganttRisk": "風險識別",
    "ganttShare": "專案經驗傳承",
    "more": "更多"
  }
}
</i18n>
